import { NgModule } from '@angular/core';

import { NgxCalendarTableFrequencyComponent } from './ngx-calendar-table-frequency.component';

@NgModule({
    imports: [],
    exports: [NgxCalendarTableFrequencyComponent],
    declarations: [NgxCalendarTableFrequencyComponent],
    providers: [],
})
export class NgxCalendarTableFrequencyModule { }
